@if (showUploadButton()) {
  <button class="photo-upload-button" (click)="onUploadPhoto()">Upload Photo</button>
}

@if (showProgress()) {
  <div class="photo-preview-container">
    <img [src]="tempImageUrl" alt="Uploading metric photo" class="photo-preview uploading" />
    <div class="photo-upload-progress-overlay">
      <div class="oph-white-spinner">
        <mat-spinner mode="determinate" [value]="uploadProgress()" diameter="24"></mat-spinner>
      </div>
    </div>
  </div>
}

@if (showImageLoading()) {
  <oph-x-button (click)="onDeletePhoto()" [width]="20" title="Remove photo"></oph-x-button>
  <div class="photo-preview-container">
    <img [src]="tempImageUrl" alt="Loading metric photo" class="photo-preview uploading" />
    <img
      [src]="currentValue()"
      alt="Loading metric photo"
      style="display: none"
      (load)="onImageLoad()"
      (error)="onImageError()"
    />
    <div class="photo-upload-progress-overlay">
      <div class="oph-green-spinner">
        <mat-spinner mode="determinate" [value]="100" diameter="24"></mat-spinner>
      </div>
    </div>
  </div>
}

@if (showPreview() && !showImageLoading()) {
  <oph-x-button (click)="onDeletePhoto()" [width]="20" title="Remove photo"></oph-x-button>
  <div class="photo-preview-container">
    <img
      [src]="currentValue()"
      alt="Uploaded metric photo"
      class="photo-preview"
      (load)="onImageLoad()"
      (error)="onImageError()"
    />
  </div>
}
